const RequestState = {
    PENDING: "PENDING",
    SUCCESS: "SUCCESS",
    ERROR: "ERROR",
    IDLE: "IDLE"
};

export default RequestState;